<template>
    <b-row
        no-gutters
        class="notification-wrapper w-100"
        v-if="notification_queue.length"
        >
        <b-col
            >
            <b-alert
                :variant="value.color"
                v-for="(value, key, index) in notification_queue"
                :key="index"
                @click.native="dismiss(value, key, index)"
                :show="value.life > 0"
                >
                <Nl2Br
                    :text="value.text"
                    tag="small"
                    >
                </Nl2Br>
            </b-alert>
        </b-col>
    </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Nl2Br from '@/components/Nl2Br.vue'

export default {
    components: {
        Nl2Br,
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters([
            'notification_queue',
        ])
    },
    methods: {
        dismiss (value, key, index) {
            value.life = 0
        },
    },
    mounted() {
//        const params = new URLSearchParams(location.search)
//        let error = null
//        if ((error = params.get('error'))) {
//            this.$store.dispatch(
//                'notification/push',
//                {
//                    text: error,
//                    color: 'danger',
//                }
//            )
//        }
//
//        window.setInterval(() => {
//            this.processFlashes()
//        }, 100)
    },
}
</script>

<style lang="scss" scoped>
.notification-wrapper {
    position: fixed;
    top: 1em;
//    width: 50%;
    text-align: left;
    z-index: 2000;
}
.notification-wrapper .alert {
//    margin-left: 1em;
    cursor: pointer;
    border-radius: 0;
    margin-bottom: 0.1rem;
}
</style>

